import { render, staticRenderFns } from "./UpSell.vue?vue&type=template&id=0a6e6e3a&scoped=true"
import script from "./UpSell.vue?vue&type=script&lang=js"
export * from "./UpSell.vue?vue&type=script&lang=js"
import style0 from "./UpSell.vue?vue&type=style&index=0&id=0a6e6e3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6e6e3a",
  null
  
)

export default component.exports